import { FormBuilder } from 'components/common-form/builder/form/FormBuilder';
import { DataContext, emptyApi } from 'components/common-form/contexts/DataContext';
import { FieldMetadataContext } from 'components/common-form/contexts/FieldMetadataContext';
import { Block } from 'components/secondaryMarket/shared/Blocks/Block';
import { DlpSecondaryProductSummaryProps } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/dlpOrder/dlpSecondaryProductSummary.connect';
import { FC, useMemo } from 'react';
import { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';
import { DataById } from 'state/formData';
import { ProductGraph } from 'state/product-description/model';

export const DlpSecondaryProductSummary: FC<DlpSecondaryProductSummaryProps> = ({
  fieldsMetadata,
  tabId,
  isFrozen,
}) => {
  const rootNodes: ProductGraph = useMemo(
    () =>
      fieldsMetadata?.map(f => ({
        id: f.id,
      })) ?? [],
    [fieldsMetadata],
  );
  const data: DataById = useMemo(
    () =>
      fieldsMetadata?.reduce(
        (newData, currentData) => ({
          ...newData,
          [currentData.id]: currentData.value,
        }),
        {},
      ) ?? {},
    [fieldsMetadata],
  );
  const metadata: FieldMetadataById = useMemo(
    () =>
      fieldsMetadata?.reduce(
        (newData, currentData) => ({
          ...newData,
          [currentData.id]: currentData,
        }),
        {},
      ) ?? {},
    [fieldsMetadata],
  );
  return (
    <Block label="form.ProductSummary" id="product-summary" fieldIds={[]}>
      <div className="row">
        <FieldMetadataContext.Provider value={metadata}>
          <DataContext.Provider value={[data, emptyApi]}>
            <div className={isFrozen ? 'dlpOrder--frozen' : ''}>
              <FormBuilder
                tabId={tabId}
                rootNodes={rootNodes}
                workspaceType={'secondaryMarketQuotes'}
                quoteWorkspaceVersion={'Standard'}
                batchWorkspaceVersion={'Standard'}
                mustForceAdvancedMode={false}
              />
            </div>
          </DataContext.Provider>
        </FieldMetadataContext.Provider>
      </div>
    </Block>
  );
};

DlpSecondaryProductSummary.displayName = 'DlpSecondaryProductSummary';
